<template>
    <div class="container-fluid">
      <div class="d-inline border-bottom border-dark text-dark">
        <a
          v-for="item in menuItems"
          :key="item.name"
          :href="item.route"
          class="px-2 text-dark"
          :class="{ 'active-link': activeItem === item.route }"
          @click="setActive(item.route)"
        >
          {{ item.label }}
        </a>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    data() {
      return {
        activeItem: window.location.pathname, // Initialize based on the current URL
        menuItems: [
          { name: 'General', label: 'General', route: '/settings/general' },
          { name: 'Payments', label: 'Payments', route: '/settings/payments' },
          { name: 'Inventory', label: 'Inventory & Orders', route: '/settings/inventory' },
          { name: 'Reports', label: 'Reports', route: '/settings/reports' },
          { name: 'Receipt', label: 'Receipt', route: '/settings/receipt' },
          { name: 'Integrations', label: 'Integrations', route: '/settings/integration' }
        ]
      };
    },
    methods: {
      setActive(route) {
        this.activeItem = route;
      }
    },
    mounted() {
      // Ensure the correct item is highlighted on page load
      this.activeItem = window.location.pathname;
    }
  };
  </script>
  
  <style scoped>
  a {
    text-decoration: none;
    cursor: pointer;
  }
  
  .active-link {
    font-weight: bold;
    color: #fd4719 !important; /* Highlight color */
    border-bottom: 2px solid #fd4719;

  }
  </style>
  